export const AuthFlowLayout = ({ children }: { children: JSX.Element | JSX.Element[] }) => (
  <div className="flex justify-center items-center min-h-screen">{children}</div>
);
